import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    justifyContent: "space-between",
  },
  headerInfo: {
    borderBottomWidth: 1,
    borderBottomColor: "#666",
    paddingBottom: 16,
  },
  title: {
    fontWeight: "bold",
    fontSize: 18,
    marginBottom: 16,
  },
  subtitle: {
    fontWeight: "bold",
    fontSize: 16,
  },
  value: {
    fontSize: 28,
    color: "#666",
  },
  cardInfo: {
    marginTop: 16,
  },
});
